/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    MyDbAdditionalDetails,
    instanceOfMyDbAdditionalDetails,
    MyDbAdditionalDetailsFromJSON,
    MyDbAdditionalDetailsFromJSONTyped,
    MyDbAdditionalDetailsToJSON,
} from './MyDbAdditionalDetails';

/**
 * @type TenantAdditionalDetails
 * tenant-specific details for additionals
 * @export
 */
export type TenantAdditionalDetails = { tenant: 'MY_DB' } & MyDbAdditionalDetails;

export function TenantAdditionalDetailsFromJSON(json: any): TenantAdditionalDetails {
    return TenantAdditionalDetailsFromJSONTyped(json, false);
}

export function TenantAdditionalDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantAdditionalDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    switch (json['tenant']) {
        case 'MY_DB':
            return {...MyDbAdditionalDetailsFromJSONTyped(json, true), tenant: 'MY_DB'};
        default:
            throw new Error(`No variant of TenantAdditionalDetails exists with 'tenant=${json['tenant']}'`);
    }
}

export function TenantAdditionalDetailsToJSON(value?: TenantAdditionalDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['tenant']) {
        case 'MY_DB':
            return MyDbAdditionalDetailsToJSON(value);
        default:
            throw new Error(`No variant of TenantAdditionalDetails exists with 'tenant=${value['tenant']}'`);
    }

}

